import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutForm from './checkoutForm';
import useQuery from 'app/hooks/useQuery';
import useMutation from 'app/hooks/useMutation';
import LoadingSpinner from 'app/common/loading-spinner';
import { goal } from 'kodyl-js/tracking';
// import * as config from 'shared/client-side-config';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

// const stripeKey = __DEV__
//   ? 'pk_test_D55VbVUAwolqQNRPaWA9okFv'
//   : 'pk_live_ju8OhQz1xi2BXmMrA7DG0JVa';
const stripePromise = loadStripe('pk_live_ju8OhQz1xi2BXmMrA7DG0JVa');

const PROVIDER_DATA = `
query Provider($providerType: ProviderType!) { provider(providerType: $providerType) { id provider publicKey } }
`;
const CREATE_SUBSCRIPTION = `
mutation CreateSubscription($input: CreateSubscriptionInput!) { createSubscription(input: $input) { id meta } }
`;

export function Stripe(props) {
  const [paymentInfo, setPaymentInfo] = React.useState(null);

  const { data } = useQuery(PROVIDER_DATA, {
    variables: {
      providerType: 'CREDIT_CARD'
    }
  });
  const { mutate } = useMutation(CREATE_SUBSCRIPTION);

  const fetchPaymentInfo = async providerId => {
    if (!paymentInfo && providerId) {
      const customer = await props.getMeta();
      const meta = {
        firstName: props.user.name,
        email: props.user.email,
        customer
      };

      const res = await mutate(CREATE_SUBSCRIPTION, {
        input: {
          providerId,
          planId: props.plan,
          meta
        }
      });
      goal({ name: 'AddPaymentInfo' });
      setPaymentInfo(res.data?.createSubscription?.meta?.paymentInfo);
    }
  };

  React.useEffect(() => {
    if (data) {
      fetchPaymentInfo(data?.provider?.id);
    }
  }, [data]);

  return paymentInfo ? (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: paymentInfo
      }}
    >
      <CheckoutForm
        i18n={props.i18n}
        error={props.error}
        modalShow={props.modalShow}
      />
    </Elements>
  ) : (
    <LoadingSpinner />
  );
}
